(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hayz-room-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hayz-room-products')) {
  customElements.define('hayz-room-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight') next = (index + direction + tabs.length) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - direction + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        });
      });
      select(0);
      this.querySelector('[role="tablist"]').hidden = false;
      this.dataset.ready = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hayz-room-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hayz-room-slideshow')) {
    customElements.define('hayz-room-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hayz-rooms__slide'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.hovered = false;
        this.focused = false;
        this.timer = null;
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('.hayz-rooms__controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), opts);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), opts);
        this.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.slide), true), opts));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, opts);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, opts);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, opts);
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, opts);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, opts);
        document.addEventListener('visibilitychange', () => this.sync(), opts);
        this.reduced.addEventListener('change', event => { if (event.matches) this.paused = true; this.sync(); }, opts);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const rtl = this.getAttribute('dir') === 'rtl';
          this.show(this.index + ((event.key === 'ArrowLeft') === rtl ? 1 : -1), true);
        }, opts);
        this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, { passive:true, ...opts });
        this.addEventListener('touchend', event => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        }, { passive:true, ...opts });
        this.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (selected >= 0) this.show(selected, true);
        }, opts);
        this.sync();
      }
      show(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) this.paused = true;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.querySelectorAll('[data-slide]').forEach((button, i) => {
          if (i === this.index) button.setAttribute('aria-current','true'); else button.removeAttribute('aria-current');
        });
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        const stopped = this.paused || this.hovered || this.focused || document.hidden;
        this.querySelector('.hayz-rooms__slides').setAttribute('aria-live', stopped ? 'polite' : 'off');
        if (!stopped) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
